import { Table, Button, Form, Input, Row, Col, DatePicker } from 'antd';
import { UserInfo } from './type';
import { atom } from 'nanostores';
import { useStore } from '@nanostores/react';
import { ColumnsType } from 'antd/es/table';
import { User } from '../api/go';
import { DateTime } from 'luxon';

const columns: ColumnsType = [
  {
    title: '日期',
    dataIndex: 'date',
    key: 'date',
  },
  {
    title: '3 天内',
    dataIndex: 'day_3',
    key: 'day_3',
  },
  {
    title: '5 天内',
    dataIndex: 'day_5',
    key: 'day_5',
  },
  {
    title: '7 天内',
    dataIndex: 'day_7',
    key: 'day_7',
  },
  {
    title: '14 天内',
    dataIndex: 'day_14',
    key: 'day_14',
  },
  {
    title: '30 天内',
    dataIndex: 'day_30',
    key: 'day_30',
  },
  {
    title: '更多',
    dataIndex: 'day_more',
    key: 'day_more',
  },
];

interface QueryForm {
  userIdList: string;
  date: any;
}

const DefaultData = {
  loading: false,
  date: '',
  day_3: '0% (0)',
  day_5: '0% (0)',
  day_7: '0% (0)',
  day_14: '0% (0)',
  day_30: '0% (0)',
  day_more: '0% (0)',
};

const store = atom(DefaultData);

async function loadList(params: QueryForm) {
  // 批量加载用户信息
  store.set({ ...store.get(), loading: true });
  const dateObj = DateTime.fromJSDate(params.date.$d);

  const userIdList = params.userIdList
    .split('\n')
    .map((s) => s.trim())
    .filter((s) => s.length === 32);
  if (userIdList.length === 0) {
    store.set({ ...DefaultData, date: dateObj.toFormat('yyyy-MM-dd') });
    return;
  }

  const resp: UserInfo[] = await User.infoList(userIdList);

  const regDay = resp.map((user) => {
    const regTime = DateTime.fromISO(user.UserRegtime);
    const diff = dateObj.diff(regTime, 'days').days;
    return Math.floor(diff);
  });
  const all = regDay.length;
  const day_3 = regDay.filter((day) => day <= 3).length;
  const day_5 = regDay.filter((day) => day <= 5).length;
  const day_7 = regDay.filter((day) => day <= 7).length;
  const day_14 = regDay.filter((day) => day <= 14).length;
  const day_30 = regDay.filter((day) => day <= 30).length;
  const day_more = regDay.filter((day) => day > 30).length;

  store.set({
    ...store.get(),
    loading: false,
    date: dateObj.toFormat('yyyy-MM-dd'),
    day_3: `${((day_3 / all) * 100).toFixed(2)}% (${day_3})`,
    day_5: `${((day_5 / all) * 100).toFixed(2)}% (${day_5})`,
    day_7: `${((day_7 / all) * 100).toFixed(2)}% (${day_7})`,
    day_14: `${((day_14 / all) * 100).toFixed(2)}% (${day_14})`,
    day_30: `${((day_30 / all) * 100).toFixed(2)}% (${day_30})`,
    day_more: `${((day_more / all) * 100).toFixed(2)}% (${day_more})`,
  });
}

export default function CheatBan() {
  const state = useStore(store);

  return (
    <div>
      <div>
        <Row>
          <Col span={8}>
            <Form
              name="list"
              layout="horizontal"
              labelCol={{ span: 8 }}
              wrapperCol={{ span: 16 }}
              style={{ maxWidth: 600 }}
              onFinish={(values: QueryForm) => {
                if (values.userIdList) {
                  loadList(values);
                }
              }}
              autoComplete="off"
            >
              <Form.Item<QueryForm> label="User ID" name="userIdList" required>
                <Input.TextArea />
              </Form.Item>
              <Form.Item<QueryForm> label="封号日期" name="date" required>
                <DatePicker />
              </Form.Item>

              <Form.Item label={null}>
                <Button type="primary" htmlType="submit" loading={state.loading}>
                  查询
                </Button>
              </Form.Item>
            </Form>
          </Col>
        </Row>
      </div>
      <div>
        <Table
          dataSource={[
            {
              date: state.date,
              day_3: state.day_3,
              day_5: state.day_5,
              day_7: state.day_7,
              day_14: state.day_14,
              day_30: state.day_30,
              day_more: state.day_more,
            },
          ]}
          columns={columns}
          pagination={false}
        />
      </div>
    </div>
  );
}
